/*
 * THE STAGED-FILE CHIPS — one look, both composers.
 *
 * A file staged before the first message and a file staged mid-conversation are the same thing to
 * the person, so they get the same chip, the same remove control and the same rejection line. Two
 * hand-rolled copies had already begun to differ in padding; this is the one they both render.
 */
import { css, html, nothing } from 'lit';
import { t } from '../i18n';
import { fmtSize } from './attachments';
import '../elements/vitesse-icon';
/** Styles for `.chips` / `.chip` / `.reject`. Spacing around the block belongs to the host. */
export const chipStyles = css `
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    padding: 4px 4px 4px 8px;
    border: 1px solid var(--border-color-light);
    border-radius: 8px;
    background: var(--bg-primary);
    font-size: 11.5px;
    color: var(--text-secondary);
  }
  .chip .nm {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chip .sz {
    color: var(--text-tertiary);
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
  }
  /* Removing an attachment is destructive, so it wears the icon-button DANGER treatment: flat,
     grows and turns red. A trash bin says "this is gone" where an x says "dismiss this". */
  .chip .icon-btn {
    color: var(--text-tertiary);
  }
  .reject {
    font-size: 11.5px;
    line-height: 1.4;
    color: var(--red);
  }
`;
/** The chips row plus the rejection line; nothing when there is nothing to show. */
export function renderChips(files, rejected, drop) {
    if (!files.length && !rejected)
        return nothing;
    return html `${files.length
        ? html `<div class="chips">
          ${files.map((f) => html `<span class="chip" title=${f.file.name}>
              <span class="nm">${f.file.name}</span>
              <span class="sz">${fmtSize(f.file.size)}</span>
              <button class="icon-btn sm danger" title=${t('ai.removeFile')} aria-label=${t('ai.removeFile')} @click=${() => drop(f.id)}>
                <vitesse-icon name="trash-2" size="13"></vitesse-icon>
              </button>
            </span>`)}
        </div>`
        : nothing}${rejected ? html `<div class="reject">${rejected}</div>` : nothing}`;
}
//# sourceMappingURL=attachment-chips.js.map